import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";

export default store => ({
  path: TRANSCRIPT_ROUTES.YEAR_GROUPS,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-yearGroups" */ "./components"
    ).then(m => m.default)
  ),
});
